import { render, staticRenderFns } from "./PersonalCard.vue?vue&type=template&id=713790a6&"
import script from "./PersonalCard.vue?vue&type=script&lang=js&"
export * from "./PersonalCard.vue?vue&type=script&lang=js&"
import style0 from "./PersonalCard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports